import Overview from '@rebuild/materials/shared/announcement/FlowXOverview.vue';
import Full from './full.vue';
import MobOverview from '@rebuild/materials/shared/announcement/mobile/MobOverviewIndex.vue';
import MobFull from './mob-full.vue';
import { withProvider } from '@rebuild/hooks/useCompWithProvider';
import { provideCurrentContext } from '@rebuild/materials/shared/announcement/context';
import { useStore } from '@/utils/vue-api';

export function useSelfContext() {
	const store = useStore();
	const marketSource = store.getters.getMarketSource;
	const findFullCode = () => {
		if (!marketSource) return '';
		return Object.values(marketSource).find(item => item.market.toUpperCase() === 'SZ')?.fullCode;
	};
	provideCurrentContext({
		forceFullCode: findFullCode()
	});
}

export const componentMap = {
	overview: withProvider(Overview, useSelfContext),
	full: withProvider(Full, useSelfContext),
	'mob-overview': withProvider(MobOverview, useSelfContext),
	'mob-full': withProvider(MobFull, useSelfContext)
};
